import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginationControllerService {
  private readonly STORAGE_KEY = 'pagination_state';
  
  private paginationState = {
    simulations: { currentPage: 1 },
    assignments: { currentPage: 1 }
  };

  constructor() {
    this.loadPaginationState();
  }

  private loadPaginationState(): void {
    try {
      const storedState = localStorage.getItem(this.STORAGE_KEY);
      if (storedState) {
        const parsedState = JSON.parse(storedState);
        this.paginationState = {
          simulations: { currentPage: parsedState.simulations?.currentPage || 1 },
          assignments: { currentPage: parsedState.assignments?.currentPage || 1 }
        };
      }
    } catch (error) {
      console.error('Error loading pagination state from localStorage:', error);
    }
  }

  private savePaginationState(): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.paginationState));
    } catch (error) {
      console.error('Error saving pagination state to localStorage:', error);
    }
  }

  getSimulationsCurrentPage(): number {
    return this.paginationState.simulations.currentPage;
  }

  setSimulationsCurrentPage(page: number): void {
    this.paginationState.simulations.currentPage = page;
    this.savePaginationState();
  }

  getAssignmentsCurrentPage(): number {
    return this.paginationState.assignments.currentPage;
  }

  setAssignmentsCurrentPage(page: number): void {
    this.paginationState.assignments.currentPage = page;
    this.savePaginationState();
  }

  resetPaginationState(): void {
    this.paginationState = {
      simulations: { currentPage: 1 },
      assignments: { currentPage: 1 }
    };
    this.savePaginationState();
  }
}
